<template>
    <div>
        <BreadCrumb v-if="mode !== 'comp' " :data="breadCrumb" />
        <Table
            :fields="fields" :items="list" :filtered="filtered" type="List" :loading="loading" :limit="limit" :setLimit="setLimit" :page="page"
            :setPage="setPage" :pageData="pageInfo" :actions="actions" :actionEvent="actionEvent" addUrl="Customer/Add" :goDetail="goDetail"
            :inputs="inputs" :search="search" :mode="mode" :gSearch="gSearch" :rightMenus="rightMenus" :rmClick="rmClick"/>

        <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" :onComplete="complete" />
    
    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb'
    import Table from "@/components/Table"
    import i18n from '@/plugins/i18n';
    import Modals from "./modals/"

    let breadCrumb = [
        { label: i18n.t('pages.customer.name'), url: "/Customer/List" },
    ]

     let fields = [ 
         { key: 'name', label: i18n.t('customer.list.title'), keys:['name'] },
         { key: 'address', label: i18n.t('customer.list.address'), keys:['address']},
         { key: 'subscribes', type:"array", label: i18n.t('customer.list.subscription'), keys:['customer_subs'] },
         { key: 'created_date', type:"date", label: i18n.t('customer.list.date'), keys:['created_date'] },
         { key: 'active', label: i18n.t('customer.list.state') , keys:['active']},
         { key: 'is_approve', label: i18n.t('customer.list.approve') , keys:['is_approve']},
         { key: 'actions', label: i18n.t('customer.list.actions')}
    ]; 
     let inputs = [ 
        { key: 'address', label: i18n.t('customer.filter.address'), type: "String", checked: false, val:""},
        { key: 'state', label:  i18n.t('customer.filter.status'), type: "Select", checked: false, val:"",  array:[
            {text: i18n.t('customer.filter.activeCustomers'), value: 1},
            {text: i18n.t('customer.filter.passiveCustomers'), value: 0},
            {text: i18n.t('customer.filter.cancelledCustomers'), value: 2}
        ]},
        { key: 'name', label:  i18n.t('customer.filter.name'), type: "String", checked: false, val:""},
        { key: 'is_approve', label:  i18n.t('customer.filter.approvalStatus'), type: "Select", checked: false, val:"", array:[
            {text: i18n.t('customer.filter.approvedCustomers'), value: true},
            {text: i18n.t('customer.filter.unapprovedCustomers'), value: false}
        ]}
    ]; 
     let actions = [
        {key: 'active', text: i18n.t('customer.list.activeAction'), state: 1},
        {key: 'passife', text: i18n.t('customer.list.suspendAction'), state: 0},
        {key: 'cancel', text: i18n.t('customer.list.cancelAction'), state: 2},
        {key: 'approve', text: i18n.t('customer.list.approveAction'), approve: true},
        {key: 'approveRemove', text: i18n.t('customer.list.unapproveAction'), approve: false},
        {key: 'approvalHistory', text: i18n.t('customer.list.approvalHistory')},
        {key: 'delete', text: i18n.t('customer.list.deleteAction')},
        {key: 'createServiceForm', text: i18n.t('customer.list.serviceForm')}
    ]
      let rightMenus = [
        {key: 'newTab', text: 'Detayı Yeni Sekmede Aç'},
        {key: 'delete', text: i18n.t('customer.list.deleteAction')},
        {key: 'approvalHistory', text: i18n.t('customer.list.approvalHistory')},
        {key: 'createServiceForm', text: i18n.t('customer.list.serviceForm')}
               
    ]

    let filtered = ['name', "address", 'subscribes', 'created_date',  'active', 'is_approve', 'actions']; 

    export default {
        name: 'CustomerList',
        created: async function(){
            await this.$store.dispatch('customer_get', {limit: this.limit, offset: this.offset})
        },
        computed:{
            fetchData(){
                this.$store.dispatch('customer_get', {limit: this.limit, offset: this.offset})
            },
            message(){
                return this.$store.getters.getCustomerInfo
            },
            loading(){
                return this.$store.getters.getLoading
            },
            list(){
                return this.$store.getters.customerList
            },
            pageInfo(){
                return this.$store.getters.getCustomerPageInfo
            }
        },
         watch:{
            limit(val){
                this.params['limit'] = val
                this.$store.dispatch('customer_get', this.params)

            },
            offset(val){
                 this.params['offset'] = val
                 this.$store.dispatch('customer_get', this.params)

            }
        },
        data: function(){
            return{
                breadCrumb, fields, filtered, limit:10, page: 1, offset: 0, actions, modalOpen: false,
                modalProps: {}, currentForm:"Customer", modalName: "", dismissCountDown: 0, inputs, rightMenus,
                params:{
                    limit:10,
                    offset: 0,
                }
            }
        },
        components:{
            BreadCrumb, Table, Modals
        },
        props:{
            mode: String
        },
        methods:{
            rmClick(key, item){
                switch(key){
                    case 'newTab':
                        window.open('/Customer/'+item.ID+'/edit', '_blank');
                        break;
                    case 'delete':
                        this.openModal(true, 'delete', item)
                        break;
                    case 'approvalHistory':
                        this.openModal(true, 'approvalHistory', item)
                        break;
                    case 'createServiceForm':
                        this.openModal(true, 'createServiceForm', item)
                        break;
                }
            },
            search(){
                this.inputs.map((input)=>{
                    input.checked ? this.params[input.key] = input.val : delete this.params[input.key] 
                })
                this.$store.dispatch('customer_get', this.params)
            },
            gSearch(data){
                data.length > 0 ? this.params['search'] = data : delete this.params['search']
                this.$store.dispatch('customer_get', this.params)
            },
            goDetail(item){
                this.$router.push( { path: '/Customer/'+item.ID+'/edit' })
            },
            complete(){
                this.dismissCountDown = 5
                this.$store.dispatch('customer_get',  this.params)
            },
            countDownChanged(dismissCountDown) {
                this.dismissCountDown = dismissCountDown
            },
            setLimit:function(limit){
                this.limit = limit
                this.$store.dispatch('customer_get',  this.params)
            },
            setPage:function(page){
                if(page > 0){
                    this.page = page
                    this.offset = ((page-1) * this.limit)
                    this.$store.dispatch('customer_get',  this.params)
                }
            },
            openModal: function(state, modal, props){
                this.modalOpen = state
                if(state){
                    this.modalProps = props
                    this.modalName = modal
                }
            },
            actionEvent: async function(key, data){
                switch(key){
                    case 'active':
                        this.openModal(true, 'SetState', {...data, state:1, type: 'state'})
                        break;
                    case 'passife': 
                        this.openModal(true, 'SetState', {...data, state:0, type: 'state'})
                        break;
                    case 'cancel':
                        this.openModal(true, 'SetState', {...data, state:2, type: 'state'})
                        break;
                    case 'delete':
                        this.openModal(true, 'delete', data)
                        break;
                    case 'approve':
                        this.openModal(true, 'SetState', {...data, is_approve: true, type: 'is_approve'})
                        break;
                    case 'approveRemove':
                        this.openModal(true, 'SetState', {...data, is_approve: false, type: 'is_approve'})
                        break;
                    case 'approvalHistory':
                        this.openModal(true, 'approvalHistory', data)
                        break;
                    case 'createServiceForm':
                        this.openModal(true, 'createServiceForm', {customerId: data.ID})
                        break;
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/General/Customer/List.vue